import { __awaiter, __generator } from "tslib";
import { decrypt } from '@office-start/encryption-utility';
import { utf8Decode } from '@office-start/text-encoding-utility';
import { dateProperties } from '../models/Constants';
import { safeParseDate } from '../utilities/DateUtilities';
export function decryptCacheEntries(cacheEntries, cryptoKey) {
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            return [2 /*return*/, Promise.all(cacheEntries.map(function (cacheEntry) { return __awaiter(_this, void 0, void 0, function () {
                    var dateReviver, decryptedBuffer, decodedDate;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!(cryptoKey && cacheEntry.item instanceof ArrayBuffer)) return [3 /*break*/, 3];
                                dateReviver = function (key, value) {
                                    if (dateProperties.has(key)) {
                                        return safeParseDate(value);
                                    }
                                    return value;
                                };
                                return [4 /*yield*/, decrypt(new Uint8Array(cacheEntry.item), cryptoKey)];
                            case 1:
                                decryptedBuffer = _a.sent();
                                return [4 /*yield*/, utf8Decode(new Uint8Array(decryptedBuffer))];
                            case 2:
                                decodedDate = _a.sent();
                                return [2 /*return*/, JSON.parse(decodedDate, dateReviver)];
                            case 3: return [2 /*return*/, cacheEntry.item];
                        }
                    });
                }); }))];
        });
    });
}
//# sourceMappingURL=decryptCacheEntries.js.map